<template>
  <v-card class="dados-gerais-container">
    <div class="dados-gerais-panel-header">
      <h4 class="titulo">Dados Gerais</h4>
    </div>
    <v-card-text v-if="paciente">
      <v-row>
        <v-col cols="12" md="3" sm="6" xs="12">
          <span class="font-weight-bold label">CPF/CNPJ</span>
          <p class="mb-0 text-truncate texto">{{ paciente.cnpjCpf | formatarCpfCnpj }}</p>
        </v-col>
        <v-col cols="12" md="3" sm="6" xs="12">
          <span class="font-weight-bold label">Data aniversário</span>
          <p class="mb-0 text-truncate texto">{{
              paciente.dataNascimento |
                  filterDate(paciente.dataNascimento)
            }}</p>
        </v-col>
        <v-col cols="12" md="3" sm="6" xs="12">
          <span class="font-weight-bold label">E-mail</span>
          <p class="mb-0 text-truncate texto">{{ paciente.email | textoSemValor }}</p>
        </v-col>
        <v-col cols="12" md="3" sm="6" xs="12">
          <span class="font-weight-bold label">Rua</span>
          <p class="mb-0 text-truncate texto">{{ paciente.logradouro | textoSemValor }}</p>
        </v-col>
        <v-col cols="12" md="3" sm="6" xs="12">
          <span class="font-weight-bold label">Número</span>
          <p class="mb-0 text-truncate texto">{{ paciente.logradouroNumero | textoSemValor }}</p>
        </v-col>
        <v-col cols="12" md="3" sm="6" xs="12">
          <span class="font-weight-bold label">Bairro</span>
          <p class="mb-0 text-truncate texto">{{ paciente.bairro | textoSemValor }}</p>
        </v-col>
        <v-col cols="12" md="3" sm="6" xs="12">
          <span class="font-weight-bold label">CEP</span>
          <p class="mb-0 text-truncate texto">{{ paciente.cep | formatarCEP }}</p>
        </v-col>
        <v-col cols="12" md="3" sm="6" xs="12">
          <span class="font-weight-bold label">Complemento</span>
          <p class="mb-0 text-truncate texto">{{ paciente.complemento | textoSemValor }}</p>
        </v-col>
        <v-col cols="12" md="3" sm="6" xs="12">
          <span class="font-weight-bold label">Contato Principal</span>
          <p class="mb-0 text-truncate texto">{{ paciente.telefone | formatarTelefone }}</p>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>

export default {
    name: 'PacienteFichaDadosGerais',
    data() {
        return {}
    },
    computed: {
        paciente() {
            return this.$store.state.paciente.dadosGerais
        }
    }
}
</script>

<style scoped lang="stylus">
.dados-gerais-container
  border solid 1px #e7e7e7
  border-radius 5px

.dados-gerais-panel-header
  border-bottom solid 1px #e7e7e7
  background-color #F6F6F6
  border-radius 5px
  border-bottom-right-radius 0
  border-bottom-left-radius 0
  padding 10px

.titulo
  font-size 15px
  font-weight bold
  color #777

.label
  font-size 13px
  font-weight bold
  color #777 !important

.texto
  font-size 13px
  color #777 !important

</style>
